/**
 * Created by neo on 23.12.22.
 */
import * as React from 'react';
import { observer } from 'mobx-react';
import { useEffect, useState } from 'react';
import { Container } from 'reactstrap';
import { ExploreContentViewRenderer } from '../../../Components/EntryView/ExploreContentViewRenderer';
import { useParams } from 'react-router-dom';
import { ExploreContentBuilder, KinasticContent } from '../../../Model/Explore/ExploreContentBuilder';
import { ExploreContentViewCategoryRenderer } from './CategoryView/ExploreContentViewCategoryRenderer';
import { useRootStore } from '../../../Store/useRootStore';
import { RelatedEntriesView } from '../../../Components/RelatedEntriesView';
import { ContentNotFound } from '../../../Components/EntryView/ContentNotFound';
import { ExploreCategory } from '../../../Model/Explore/ExploreCategory';

export type AcademyContentViewScreenProps = {};

export const AcademyContentViewScreen: React.FC<AcademyContentViewScreenProps> = observer((props) => {
  const { analytics } = useRootStore();

  const [content, setContent] = useState<KinasticContent | undefined>();
  const [lastError, setLastError] = useState<unknown>(undefined);
  const [loading, setLoading] = useState(true);

  const { contentId } = useParams<{ contentId: string }>();

  useEffect(() => {
    setContent(undefined);
    setLastError(undefined);
    if (contentId) {
      setLoading(true);
      ExploreContentBuilder.findOne(contentId)
        .then((res) => setContent(res))
        .catch((e: unknown) => setLastError(e))
        .finally(() => setLoading(false));
    } else {
      setLoading(false);
    }
  }, [contentId]);

  useEffect(() => {
    if (content) {
      const type = content.type === 'recipe' ? 'recipe' : content.type;
      analytics.logSelectContent(type, content.id);
    }
  }, [analytics, content]);

  if (content) {
    if ('contentType' in content && content.contentType === 'category' && 'identifier' in content) {
      return (
        <Container>
          <ExploreContentViewCategoryRenderer category={content as ExploreCategory} />
        </Container>
      );
    }
    const exploreEntry = 'backgroundImage' in content ? content : undefined;
    return (
      <React.Fragment>
        <ExploreContentViewRenderer entry={content} />
        {exploreEntry && <RelatedEntriesView entry={exploreEntry} linkPrefix={'/academy/'} />}
      </React.Fragment>
    );
  }

  if (loading) {
    return <Container style={{ padding: '48px', textAlign: 'center' }}>Loading...</Container>;
  }

  return lastError ? <ContentNotFound /> : null;
});
